import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface CustomShippingFieldParameterValid extends ApiParameter {
    receiverContactNameValid?: boolean;
}

export interface CustomShippingFieldModel {
    receiverContactNameValid?: boolean;
}

type HandlerType = CustomApiHandler<CustomShippingFieldParameterValid, CustomShippingFieldModel>;

export const DispatShippingReciverContactNameValid: HandlerType = (props: any) => {
    props.dispatch({
        type: "ShippingPage/CustomFields/receiverContactNameValid",
        result: props.parameter.receiverContactNameValid,
    });
};

export const chain = [DispatShippingReciverContactNameValid];

const customShippingFieldReceiverNameValid = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "CustomShippingFieldReceiverNameValid",
);
export default customShippingFieldReceiverNameValid;
